import { Component, OnInit } from '@angular/core';
import * as numbro from 'numbro';
import * as numbroLanguages from 'numbro/dist/languages.min';

// import {SwUpdate} from '@angular/service-worker';
import { RoutingConfigService } from './core/services/config/routing-config.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})

export class AppComponent implements OnInit {
  // private swUpdate: SwUpdate,
  constructor(private _routing: RoutingConfigService, private _router: Router) {
    numbro.registerLanguage(numbroLanguages['pt-BR']);
    numbro.setLanguage('pt-BR');
  }

  ngOnInit() {
    this._routing.routeRedirect();
    const connect = localStorage.getItem('connect');
    if (!connect) {
      localStorage.removeItem('token');
      localStorage.removeItem('usuario');
      localStorage.setItem('connect', '1');
      this._router.navigateByUrl('/login');

    }
    //novo commit
    // if (this.swUpdate.isEnabled) {
    //   this.swUpdate.available.subscribe(() => {
    //     if (confirm('Nova Versão disponível. Deseja carregá-la?')) {
    //       window.location.reload();
    //     }
    //   });
    // }
  }
}
